import { atom } from 'recoil';
import { ModalData } from 'models/AutoModals';


const modal = atom<ModalData[]>({
    key: 'modal',
    default: [],
});

export default modal;
